import { render, staticRenderFns } from "./TextAnnotationField.vue?vue&type=template&id=660fda6f"
import script from "./TextAnnotationField.vue?vue&type=script&lang=js"
export * from "./TextAnnotationField.vue?vue&type=script&lang=js"
import style0 from "./TextAnnotationField.vue?vue&type=style&index=0&id=660fda6f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports